export default [{
    path: "/",
    name: "hometest2",
    component: () => import("@/views/HomeNew.vue")
  },{
    path: "/login",
    name: "newlogin",
    component: () => import("@/views/NewLogin.vue")
  },{
    path: "/simulacion-cuotas",
    name: "simulacion-cuotas",
    component: () => import("@/views/SimulacionCuotas.vue")
  },{
    path: "/radian",
    name: "radian",
    component: () => import("@/views/Radian.vue")
  },{
    path: "/documentos-descargables",
    name: "documentos-descargables",
    component: () => import("@/views/DocumentosDescargables.vue")
  },{
    path: "/referidos/:id",
    name: "QuestionsReferidos",
    component: () => import("@/views/QuestionsReferidos.vue"),
    props: true
  },{
    path: "/simulacion-facturas",
    name: "simulacion-facturas",
    component: () => import("@/views/SimulacionFacturas.vue")
  },{
    path: "/solicitante",
    name: "solicitante",
    component: () => import("@/views/Applicant.vue")
  },{
    path: "/contacto",
    name: "contact",
    component: () => import("@/views/Contact.vue")
  },
  /* {
    path: "/quienes-somos",
    name: "about",
    component: () =>
      import("@/views/About.vue")
  }, */
  {
    path: "/quienes-somos",
    name: "about",
    component: () => import("@/views/aboutUs/AboutUs.vue")
  },{
    path: "/como-funciona-invertir",
    name: "comofuncionainvertir",
    component: () => import("@/views/HowItWorksNew.vue")
  },{
    path: "/como-funciona",
    redirect: "como-funciona-invertir"
  },{
    path: "/solicitar-credito",
    name: "request-credit",
    component: () => import("@/views/Credit.vue")
  },{
    path: "/garantia-riesgos",
    name: "warrantyrisk",
    component: () => import("@/views/Warranty.vue")
  },{
    path: "/preguntas-frecuentes",
    name: "faq",
    component: () => import("@/views/Faq.vue")
  },{
    path: "/politica-privacidad",
    name: "politica-privacidad",
    component: () => import("@/views/Politicas-privacidad.vue")
  },{
    path: "/protocolo-cobranza",
    name: "protocolo-cobranza",
    component: () => import("@/views/Protocolo-cobranza.vue")
  },{
    path: "/registrar",
    name: "register",
    component: () => import("@/views/Register.vue"),
    props: true
  },{
    path: "/registro",
    name: "register-requests",
    component: () => import("@/views/Register.vue")
  },{
    path: "/recuperar",
    name: "recuperar",
    component: () => import("@/views/Recover.vue")
  },{
    path: "/recuperar/:token",
    name: "recuperar contraseña",
    component: () => import("@/views/NewPassword.vue"),
    props: true
  },{
    path: "/prensa",
    name: "press",
    component: () => import("@/views/Press.vue")
  },{
    path: "/agenda-llamada-exitosa",
    name: "schedule-call-success",
    component: () => import("@/views/ScheduleCallSuccess.vue")
  },{
    path: "/simulacion/proyecto-:projectId",
    name: "simulation",
    component: () => import("@/views/Simulation.vue"),
    props: true
  },{
    path: "/inversion-realizada",
    name: "investment-completed",
    component: () => import("@/views/InvestmentCompleted.vue")
  },{
    path: "/bueno-saberlo",
    name: "good-to-know",
    component: () => import("@/views/GoodToKnow.vue")
  },
  {
    path: "/seguridad",
    name: "security",
    component: () => import("@/views/Security.vue"),
  },
]